import isObject from 'lodash/fp/isObject';
import mergeWith from 'lodash/fp/mergeWith';

const mergeTranslations = mergeWith((value, srcValue) => {
    if (Array.isArray(value)) {
        // we need to check for arrays first before object otherwise isObject will give us a fake positive
        return srcValue;
    }

    if (isObject(value)) {
        // recursive action
        return mergeTranslations(value, srcValue);
    }

    return srcValue;
});

export default mergeTranslations;
